var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BookModel } from '../BookModel';
import { CourseTimespansQuantityStepModelCollection } from './CourseTimespansQuantityStepModelCollection';
var CourseTimespansQuantityStepModel = /** @class */ (function (_super) {
    __extends(CourseTimespansQuantityStepModel, _super);
    function CourseTimespansQuantityStepModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseTimespansQuantityStepModel.getCollectionClass = function () {
        return CourseTimespansQuantityStepModelCollection;
    };
    Object.defineProperty(CourseTimespansQuantityStepModel.prototype, "minQuantity", {
        get: function () {
            return this.get("minimum_quantity");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespansQuantityStepModel.prototype, "maxQuantity", {
        get: function () {
            return this.get("maximum_quantity");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespansQuantityStepModel.prototype, "stepSize", {
        get: function () {
            return this.get("step_size");
        },
        enumerable: false,
        configurable: true
    });
    CourseTimespansQuantityStepModel.prototype.split = function (left, right, parts) {
        var result = [];
        var delta = left + parts;
        while (delta <= right) {
            result.unshift(delta);
            delta += parts;
        }
        return result;
    };
    CourseTimespansQuantityStepModel.prototype.getStepRange = function (_a) {
        var max_quantity = _a.max_quantity;
        return this.split(0, Math.min(this.maxQuantity, Number(max_quantity)), this.stepSize);
    };
    CourseTimespansQuantityStepModel.times = ['from_time', 'to_time'];
    CourseTimespansQuantityStepModel.dates = ['from', 'to'];
    return CourseTimespansQuantityStepModel;
}(BookModel));
export { CourseTimespansQuantityStepModel };
